// stock 前後端共用的資料結構
// jkSelf ../app/_link2
// jkOrm/src/_link
// 此檔與前端共用
import { jkBaseLibClass, login } from "jk-service";
import { jkRestReturn, jkLib, } from "jk-service";
import {
  SMA,
  EMA,
  CCI,
  BollingerBands as BB,
  Stochastic as KD,
} from "technicalindicators";
import { BollingerBandsOutput } from "technicalindicators/declarations/volatility/BollingerBands";
import { macd } from "technicalindicators";
import { Stklb, Stklg, Stkma, Stkml, Stktm, Stktn } from "../_entity_stk";
import { SKSTOCKLONG, StockQuoteCapital } from "../capitalClass";
//import macd from "macd";
// import { MACDInput, MACDOutput } from "technicalindicators/declarations/moving_averages/MACD";

export declare class IndicatorInput {
  reversedInput?: boolean;
  format?: (data: number) => number;
}

export declare class MACDInput extends IndicatorInput {
  values: number[];
  SimpleMAOscillator: boolean;
  SimpleMASignal: boolean;
  fastPeriod: number;
  slowPeriod: number;
  signalPeriod: number;
  constructor(values: number[]);
}
export declare class MACDOutput {
  MACD?: number;
  signal?: number;
  histogram?: number;
}

// 股價 分/日技術線 (時間序列) 併到StockData
/*
export class StockPrice {
    time: Date;
    timeStr: string;
    date: string;
    open: number;
    high: number;
    low: number;
    close: number;
    YClose: number;// 昨收
    qty: number;
    YQty: number; // 昨天量
    //Name: string;
    ma5: number;
    ma5Dir: number;
    ma10: number;
    ma10Dir: number;
    sma5: number;
    sma5Dir: number;
    sma10: number;
    sma10Dir: number;
    sma20: number; // 同布林中軌
    sma20Dir: number; // 同布林中軌方向
    sma60: number;
    sma60Dir: number;
    UB: number; // 布林上軌
    UBdir: number; // 布林上軌方向
    LB: number; // 布林下軌
    LBdir: number; // 布林下軌方向
    //modiTime: Date; // 資料更新時間
    decimal: number; // 小數位數
}*/

/**
 * 股價技術分析 (時間序列) 可對應 STKLG
 */
export class StockData {
  importStklgV02(data: any) {
    if (!data) return;
    this.stockno = data.stockno;
    this.stockName = data.stockName;
    this.datetime = data.datetime1;
    this.date = data.date1;
    this.time = data.time1;
    this.yClose = data.yClose;
    this.yQty = data.yQty;
    this.qty = data.qty;
    this.open = data.open;
    this.close = data.close;
    this.high = data.high;
    this.low = data.low;
    this.avg = data.avg;
    this.updown = data.updown;
    this.pricePercent = data.pricePercent;
    this.qtyPercent = data.qtyPercent;
    this.updownRate = data.updownRate;
    this.yield = data.yield;
    this.PEratio = data.PEratio;
    this.bias5 = data.bias5;
    this.bias10 = data.bias10;
    this.bias20 = data.bias20;
    this.bias60 = data.bias60;
    this.ma5 = data.ma5;
    this.ma10 = data.ma10;
    this.sma5 = data.sma5;
    this.sma10 = data.sma10;
    this.sma20 = data.sma20;
    this.sma60 = data.sma60;
    this.sma120 = data.sma120;
    this.sma240 = data.sma240;
    this.sma5Dir = data.sma5Dir;
    this.sma10Dir = data.sma10Dir;
    this.sma20Dir = data.sma20Dir;
    this.sma60Dir = data.sma60Dir;
    this.isSmaUp3 = data.isSmaUp3;
    this.isSmaUp4 = data.isSmaUp4;
    this.highTime = data.highTime;
    this.lowTime = data.lowTime;
    this.KSize = data.KSize;
    this.KHighShadow = data.KHighShadow;
    this.KLowShadow = data.KLowShadow;
    this.analysis = data.analysis;
    this.UBT = data.UBT;
    this.UBdir = data.UBdir;
    this.LBT = data.LBT;
    this.LBdir = data.LBdir;
    this.BBIndex = data.BBIndex;
    this.BBandBW = data.BBandBW;
    this.macd = data.macd;
    this.dif = data.dif;
    this.osc = data.osc;
    this.K = data.K;
    this.D = data.D;
    this.buyPoint = data.buyPoint;
    this.weekPercent = data.weekPercent;
    this.monthPercent = data.monthPercent;
    this.seasonPercent = data.seasonPercent;
    this.state = data.state;
    this.KLineStyle = data.KLineStyle;
    this.newPrice = data.newPrice;
    this.updateTime = data.updateTime;

  }
  stockno: string = "";
  stockName: string = "";
  datetime: Date = new Date();
  date: string = "";
  time!: string;
  yClose!: number; // 昨收 yClose
  yQty!: number; // 昨日成交量 yQty
  qty!: number; //日成交量 LB003 qty
  open!: number; // 日LB005    開盤價 open
  close!: number; // LB008    收盤價 close
  high!: number; // high 最高價
  low!: number; // low 最低價
  avg!: number; // avg 均價
  updown!: number; // 漲跌 updown
  pricePercent!: number; //價漲跌幅 pricePercent
  qtyPercent!: number; //量增幅 qtyPercent
  updownRate!: number; // 日漲跌幅/振幅 updownRate
  yield!: number; // 殖利率
  PEratio!: number; // 本益比
  bias5!: number; // MA5 乖離率 bias5
  bias10!: number; // MA10 乖離率 bias10
  bias20!: number; // MA20 乖離率 bias20
  bias60!: number; // MA60 乖離率 bias60
  ma5!: number;
  ma10!: number;
  sma5!: number; // LB012
  sma10!: number; // LB013
  sma20!: number; // LB014
  sma60!: number; // LB018
  sma120!: number; // LB019
  sma240!: number; // LB020
  sma5Dir!: number; // 方向
  sma10Dir!: number; // 方向
  sma20Dir!: number; // 方向
  sma60Dir!: number;
  isSmaUp3!: boolean; //三陽開泰
  isSmaUp4!: boolean; // 四海遊龍
  highTime!: Date;
  lowTime!: Date;
  //KType: string = '';
  KSize!: number; // K棒大小 %.(收盤-開盤)/昨收
  KHighShadow!: number; // 上影線 KSize>=0: (最高-收盤)/昨收 KSize < 0:(最高-開盤
  KLowShadow!: number; // 下影線 KSize>=0: (開盤-最低)/昨收 KSize < 0:(收盤-最低
  analysis: string[] = []; // 操盤分析
  UBT!: number; // 布林上軌
  UBdir!: number; // 布林上軌方向
  LBT!: number; // 布林下軌
  LBdir!: number; // 布林下軌方向
  BBIndex: number = 0;//  B指標                       N   8.4   在BBand中位置  %b值 = (收盤價?布林帶下軌值) ÷ (布林帶上軌值?布林帶下軌值)
  BBandBW: number = 0; // 布林帶寬度 LG018    BBAND_BW                    N    8.4 BBandBW  帶寬指標值 = (布林帶上軌值?布林帶下軌值) ÷布林帶中軌值
  macd: number = 0; // LG019    MACD                        N   11.3 macd LB024
  dif: number = 0; // LG020    DIF                         N   11.3 dif LB023
  osc: number = 0; // LG021    OSC                         N   11.3 osc
  K: number = 0; // LG029    K(9,3)					  N    8.4 K LB025
  D: number = 0; // LG030    D(9,3)					  N    8.4 D LB026
  buyPoint: number = 0; // LG031    買賣評分                    N    4   buyPoint LB031
  weekPercent: number = 0; // LG032    週漲%                       N   8.4  weekPercent LB037 $A5=5日前收盤LG010  (LG010-$A5)/$A5
  monthPercent: number = 0; // LG033    月漲%                       N   8.4  monthPercent LB038  $A20=20日前收盤LG010  (LG010-$A20)/$A20
  seasonPercent: number = 0; // LG034    季漲%                       N   8.4  seasonPercent LB039  $A60=60日前收盤LG010  (LG010-$A60)/$A60
  state: string = ''; // LG040    狀態                        V   10   state LB051  未開盤 開盤 試算isTrial 已收盤 isCloseed
  KLineStyle: string = ''; // LG041    K線型態                     V   255  KLineStyle LB063  TODO:   吊人線 墓碑線 多頭吞噬 空頭吞噬 ....
  newPrice: number = 0; //  LG042    最新一筆成交價格            N   11.2 newPrice LB055
  updateTime?: Date; // 0011 LG012    更新時間                    D    X   updateTime LB054
  /**
   *
   * @returns {string} - 現價: 漲跌: 漲跌幅:...
   */
  displayPrices(): string {
    let s =
      "現價:" +
      this.close +
      " 漲跌:" +
      this.updown +
      " 漲跌幅:" +
      jkLib.percentStr(this.pricePercent, 1) +
      " 量增幅:" +
      jkLib.percentStr(this.qtyPercent, 1) +
      " 離季線:" +
      stockConv.smaOffStr(this, 60) +
      " 昨收:" +
      this.yClose +
      " 成交量:" +
      String(this.qty) +
      " 振幅:" +
      jkLib.percentStr(this.updownRate, 1) +
      " 開盤:" +
      this.open +
      " 最高:" +
      String(this.high) +
      " 最低:" +
      String(this.low);
    return s;
  }
}

export class StockQuote extends StockData {
  //stockno!: string;
  //stockName!: string;
  notice: string = ""; // 觀盤重點
  stkma006: string = ''; //    摘要
  stkma047: string = ''; // V  500   依群組排序

  importStktm(data: Stktm) {
    this.stockno = data.TM002;
    this.stockName = data.TM003;
    this.notice = data.TM012;  //TM012    觀盤重點
  }
  importStkma(data: Stkma) {
    this.stkma006 = data.MA006; //    摘要
    this.stkma047 = data.MA047; // V  500   群組
  }
}
/**
 * 股票資訊轉換
 */
export class stockConvert {
  smaOffStr(item: StockData, days: number): string {
    let r = "";
    let f = this.smaOff(item, days);
    let fn = "sma" + days.toString();
    r =
      String(jkLib.fourOutFiveIn(item.close - (item as any)[fn], 2)) +
      "(" +
      String(jkLib.fourOutFiveIn(f * 100, 3)) +
      "%)";
    return r;
  }
  smaOff(item: StockData, days: number): number {
    // 60:離季線
    let f = 0;
    let fn = "sma" + days.toString();
    f = jkLib.fourOutFiveIn((item.close - (item as any)[fn]) / item.yClose, 4);
    return f;
  }
  stklb2stklg(lb: Stklb, lg: Stklg) {
    lg.LG001 = lb.LB002;
    lg.LG002 = "日線";
    lg.LG003 = "0000";
    lg.LG004 = lb.LB001;
    lg.LG005 = lb.LB003;
    lg.LG006 = lb.LB004;
    lg.LG007 = lb.LB005;
    lg.LG008 = lb.LB006;
    lg.LG009 = lb.LB007;
    lg.LG010 = lb.LB008;
    lg.LG011 = lb.LB035;
    lg.LG012 = lb.LB054;
    lg.LG013 = lb.LB059;
    lg.LG014 = lb.LB032;
    lg.LG015 = lb.LB034;
    //lg.LG016 = lb.LB016;
    lg.LG017 = lb.LB033;
    //lg.LG018 = lb.LB018;
    lg.LG019 = lb.LB024;
    lg.LG020 = lb.LB023;
    //lg.LG021 = lb.LB021;
    lg.LG022 = lb.LB058;
    lg.LG023 = lb.LB036;
    lg.LG024 = lb.LB009;
    lg.LG025 = lb.LB012;
    lg.LG026 = lb.LB013;
    lg.LG027 = lb.LB014;
    lg.LG028 = lb.LB018;
    lg.LG029 = lb.LB025;
    lg.LG030 = lb.LB026;
    lg.LG031 = lb.LB031;
    lg.LG032 = lb.LB037;
    lg.LG033 = lb.LB038;
    lg.LG034 = lb.LB039;
    lg.LG035 = lb.LB040;
    lg.LG036 = lb.LB046;
    lg.LG037 = lb.LB047;
    lg.LG038 = lb.LB048;
    lg.LG039 = lb.LB049;
    lg.LG040 = lb.LB051;
    lg.LG041 = lb.LB063;
    lg.LG042 = lb.LB055;
    lg.LG043 = lb.LB064;
    lg.LG044 = lb.LB065;
    lg.LG045 = lb.LB061;
    lg.LG046 = lb.LB062;
    lg.LG047 = lb.LB016;
    lg.LG048 = lb.LB017;
  }

  CapitalSKSTOCKLONG2StockQuote(ca: SKSTOCKLONG, quote: StockQuoteCapital) {
    let dev00 = 100;

    if (ca.sDecimal === 1) dev00 = 10;
    if (ca.sDecimal === 2) dev00 = 100;
    if (ca.sDecimal === 3) dev00 = 1000;

    quote.nStockidx = ca.nStockidx;
    quote.bstrMarketNo = ca.bstrMarketNo;
    quote.bstrStockNo = ca.bstrStockNo;
    quote.bstrStockName = ca.bstrStockName;
    quote.nHigh = ca.nHigh / dev00;
    quote.nOpen = ca.nOpen / dev00;
    quote.nLow = ca.nLow / dev00;
    quote.nClose = ca.nClose / dev00;
    quote.nTickQty = ca.nTickQty;
    quote.nRef = ca.nRef / dev00;
    quote.nBid = ca.nBid / dev00;
    quote.nBc = ca.nBc;
    quote.nAsk = ca.nAsk / dev00;
    quote.nAc = ca.nAc;
    quote.nTBc = ca.nTBc;
    quote.nTAc = ca.nTAc;
    quote.nFutureOI = ca.nFutureOI;
    quote.nTQty = ca.nTQty;
    quote.nYQty = ca.nYQty;
    quote.nUp = ca.nUp / dev00;
    quote.nDown = ca.nDown / dev00;
    quote.nSimulate = ca.nSimulate;
    quote.nDayTrade = ca.nDayTrade;
    quote.nTradingDay = ca.nTradingDay;
    quote.sTypeNo = ca.sTypeNo;
  }
  parseCapital(item: StockData, data: string) {
    while (data !== "") {
      let ary2 = jkLib.cutToken(data, ",");
      data = ary2[1];
      let rec = ary2[0];
      let mFieldName = jkLib.getToken(rec, "=", 1);
      let value = jkLib.getToken(rec, "=", 2);
      if (mFieldName === "") {
        continue;
      }
      /*
            Object.keys(this).forEach(element => {
              if(element===mFieldName){
                this[element] = value;
              }
            });*/
      if (mFieldName === "time") {
        item.time = value;
      }
      //if (mFieldName === 'm_caStockNo') { item.stockNo = value; };
      //if (mFieldName === 'm_caName') { item.name = value; };
      if (mFieldName === "m_nOpen") {
        item.open = Number(value);
      }
      if (mFieldName === "m_nHigh") {
        item.high = Number(value);
      }

      if (mFieldName === "m_nLow") {
        item.low = Number(value);
      }
      if (mFieldName === "m_nClose") {
        item.close = Number(value);
      }
      if (mFieldName === "m_nRef") {
        item.yClose = Number(value);
      }
      if (mFieldName === "m_nYQty") {
        item.yQty = Number(value);
      }
      if (mFieldName === "m_nTQty") {
        item.qty = Number(value);
      }

      /**m_caStockNo=TX00,m_caName=台指近,m_nOpen=12920,m_nHigh=12975,m_nLow=12854,m_nClose=12911,
             * m_nTickQty=1,m_nRef=12956,m_nBid=12910,m_nBc=6,m_nAsk=12911,m_nAc=2,m_nTQty=63492,m_nYQty=0,||time:00:27:15,m_caStockNo=MTX00,m_caName=小台近,m_nOpen=12924,m_nHigh=12976,m_nLow=12854,m_nClose=12910,m_nTickQty=13,m_nRef=12956,m_nBid=12910,m_nBc=2,m_nAsk=12911,m_nAc=12,m_nTQty=142419,m_nYQty=0,||time:00:27:15,m_caStockNo=CZF00,m_caName=長榮近,m_nOpen=140,m_nHigh=143,m_nLow=137,m_nClose=142.5,m_nTickQty=1,m_nRef=139,m_nBid=142.5,m_nBc=186,m_nAsk=143,m_nAc=927,m_nTQty=6685,m_nYQty=9881,||"}
               time:00:27:20,m_caStockNo=TX00,m_caName=台指近,m_nOpen=12920,m_nHigh=12975,m_nLow=12854,m_nClose=12910,m_nTickQty=7,m_nRef=12956,m_nBid=12909,m_nBc=8,m_nAsk=12910,m_nAc=2,m_nTQty=63500,m_nYQty=0,||time:00:27:20,m_caStockNo=MTX00,m_caName=小台近,m_nOpen=12924,m_nHigh=12976,m_nLow=12854,m_nClose=12910,m_nTickQty=3,m_nRef=12956,m_nBid=12909,m_nBc=12,m_nAsk=12910,m_nAc=6,m_nTQty=142425,m_nYQty=0,||time:00:27:20,m_caStockNo=CZF00,m_caName=長榮近,m_nOpen=140,m_nHigh=143,m_nLow=137,m_nClose=142.5,m_nTickQty=1,m_nRef=139,m_nBid=142.5,m_nBc=186,m_nAsk=143,m_nAc=927,m_nTQty=6685,m_nYQty=9881,||"} */
      //item.masterStore
    }
  }
}

export let stockConv: stockConvert = new stockConvert();

/**
 * 單一商品.一段時間資料
 */
export class stockListClass {
  // old: dayEntityClass
  //itemList: StockData[] = [];
  //item: StockData;
  stockno!: string;
  stockName!: string;
  score!: number;
  analysis: string[] = []; // 操盤分析
  state!: string;
  highTime: Date | undefined;
  lowTime: Date | undefined;
  qty!: number;
  date1!: string;
  date2!: string;
  time1!: string;
  time2!: string;
  descript!: string;
  //STKMA041: number;//突破通知價
  // STKMA042: number;跌破通知價
  //STKMA048: number;
  //STKMA049: number;
  //STKMA043: number;
  //STKMA044: number;
  //STKMA050: number;
  //STKMA045: number;
  tickInterval: number = 50;
  listMax: number = 100;
  listMin: number = 1;
  doParseList(itemList: StockData[]) {
    // TODO:分析 itemList=> listMin, listMax, highTime, lowTime,tickInterval
    let max = 0;
    let min = 999999;
    for (let i = 0; i < itemList.length; i++) {
      let item = itemList[i];
      if (item.high > max) {
        max = item.high;
        this.highTime = item.datetime;
      };
      if (item.low < min) {
        min = item.low;
        this.lowTime = item.datetime;
      }
    }
    this.listMax = max;
    this.listMin = min;
    this.tickInterval = Math.round((max - min) / 10);
  }
  reCalc(item: StockData) {
    item.KSize = jkLib.fourOutFiveIn(
      (item.close - item.open) / item.yClose,
      3
    );
    if (item.KSize >= 0) {
      item.KHighShadow = jkLib.fourOutFiveIn(
        (item.high - item.close) / item.yClose,
        3
      );
      item.KLowShadow = jkLib.fourOutFiveIn(
        (item.open - item.low) / item.yClose,
        3
      );
    } else {
      item.KHighShadow = jkLib.fourOutFiveIn(
        (item.high - item.open) / item.yClose,
        3
      );
      item.KLowShadow = jkLib.fourOutFiveIn(
        (item.close - item.low) / item.yClose,
        3
      );
    }
  }
  getAnalysis(): string {
    return this.analysis.join(",");
  }
  is3Sun(item: StockData): boolean {
    // 三陽開泰
    // FIXME: 短天期均線 在長天期之上 還是 均線皆上揚?
    //收盤價> 5 MA > 20 MA
    let b1 = false;
    let b2 = false;
    let b3 = false;
    if (item.sma5 > item.sma10 && item.sma10 > item.sma20) {
      b1 = true;
    }

    if (item.sma5Dir > 0 && item.sma10Dir > 0 && item.sma20Dir > 0) {
      b2 = true;
    }
    if (item.close >= item.sma5) b3 = true;
    return b1 && b2 && b3;
  }
  is4Dragon(item: StockData): boolean {
    // 四海遊龍
    let b1 = false;
    let b2 = false;
    let b3 = false;
    if (
      item.sma5 > item.sma10 &&
      item.sma10 > item.sma20 &&
      item.sma20 > item.sma60
    ) {
      b1 = true;
    }
    if (
      item.sma5Dir > 0 &&
      item.sma10Dir > 0 &&
      item.sma20Dir > 0 &&
      item.sma60Dir > 0
    ) {
      b2 = true;
    }
    if (item.close >= item.sma5) b3 = true;
    return b1 && b2 && b3;
  }
  // 先匯入昨日 再匯入今日 比較好計算
  importStklb(item: StockData, stkma: Stkma, lb0: Stklb, lb1: Stklb) {
    if (!lb0) return;
    if (!lb1) return;
    /*this.STKMA041 = stkma.MA041; // 突破通知價
    this.STKMA042 = stkma.MA042; // 跌破通知價
    this.STKMA048 = stkma.MA048; // 支撐1
    this.STKMA049 = stkma.MA049; // 支撐2
    this.STKMA043 = stkma.MA043; // 停損價
    this.STKMA044 = stkma.MA044; // 第一停利價
    this.STKMA050 = stkma.MA050; // 壓力
    this.STKMA045 = stkma.MA045; // 第二停利價*/
    // 昨日
    this.stockno = lb1.LB001;
    this.stockName = stkma.MA002;
    this.descript = stkma.MA006;
    this.score = lb0.LB031; //    買賣評分
    this.state = lb0.LB051; //   狀態                        V   10   TM004 data.quote 未開盤 開盤 試算isTrial 已收盤 isCloseed
    this.highTime = lb0.LB052; //   最高價時間                  D    X   TM008 quote.priceHigh.at
    this.lowTime = lb0.LB053; //   最低價時間                  D    X   TM010 quote.priceLow.at

    item.yQty = lb1.LB003;
    item.yClose = lb1.LB008;
    // 今天
    item.date = lb0.LB002;
    if (!item.time) {
      item.time = jkLib.date2Time8(lb1.LB054);
    }
    item.close = lb0.LB008;
    item.open = lb0.LB005;
    item.high = lb0.LB006;
    item.low = lb0.LB007;
    item.qty = lb0.LB003;
    item.avg = lb0.LB011; //  均價  只有櫃買才有
    item.updown = lb0.LB009; // 漲跌
    item.pricePercent = lb0.LB036; // 漲跌幅
    item.updownRate = lb0.LB058; // (LB006-LB007)/LB035
    item.ma5 = lb0.LB016;
    item.qtyPercent = jkLib.fixNumber(
      jkLib.fourOutFiveIn(item.qty / item.ma5, 2)
    ); //lb0.LB040盤後才重計得到. ;//成交量增減%
    item.ma10 = lb0.LB017;
    item.sma5 = lb0.LB012;
    item.sma10 = lb0.LB013;
    item.sma20 = lb0.LB014;
    item.sma60 = lb0.LB018;
    item.sma120 = lb0.LB019;
    item.sma240 = lb0.LB020;

    item.bias5 = jkLib.fourOutFiveIn(
      (item.close - item.sma5) / item.yClose,
      3
    );
    item.bias10 = jkLib.fourOutFiveIn(
      (item.close - item.sma10) / item.yClose,
      3
    );
    item.bias20 = jkLib.fourOutFiveIn(
      (item.close - item.sma20) / item.yClose,
      3
    );
    item.sma5Dir = this.compareOldNew(lb1.LB012, lb0.LB012, 0);
    item.sma10Dir = this.compareOldNew(lb1.LB013, lb0.LB013, 0);
    item.sma20Dir = this.compareOldNew(lb1.LB014, lb0.LB014, 0);
    item.sma60Dir = this.compareOldNew(lb1.LB018, lb0.LB018, 0);
    item.isSmaUp3 = this.is3Sun(item);
    item.isSmaUp4 = this.is4Dragon(item);
    if (item.isSmaUp3) item.analysis.push("三陽開泰");
    if (item.isSmaUp4) item.analysis.push("四海遊龍");
    this.reCalc(item);
  }
  importStklg(item: StockData, stkma: Stkma, tm: Stktm, lg0: Stklg, lg1: Stklg, lg002: string) {// 周期(分)
    if (!lg0) return;
    if (!lg1) return;
    /*this.STKMA041 = stkma.MA041; // 突破通知價
    this.STKMA042 = stkma.MA042; // 跌破通知價
    this.STKMA048 = stkma.MA048; // 支撐1
    this.STKMA049 = stkma.MA049; // 支撐2
    this.STKMA043 = stkma.MA043; // 停損價
    this.STKMA044 = stkma.MA044; // 第一停利價
    this.STKMA050 = stkma.MA050; // 壓力
    this.STKMA045 = stkma.MA045; // 第二停利價*/
    // 昨日
    this.stockno = tm.TM002;
    this.stockName = tm.TM003;
    this.descript = stkma.MA006;
    this.score = lg0.LG031; //    買賣評分
    this.state = lg0.LG040; //   狀態                        V   10   TM004 data.quote 未開盤 開盤 試算isTrial 已收盤 isCloseed
    //this.highTime = lg0.LB052; //   最高價時間                  D    X   TM008 quote.priceHigh.at
    //this.lowTime = lg0.LB053; //   最低價時間                  D    X   TM010 quote.priceLow.at

    item.yQty = lg1.LG005;
    item.yClose = lg1.LG010;
    // 今天
    item.date = lg0.LG001;
    if (!item.time) {
      item.time = jkLib.date2Time8(lg1.LG012);
    }
    item.close = lg0.LG010;
    item.open = lg0.LG007;
    item.high = lg0.LG008;
    item.low = lg0.LG009;
    item.qty = lg0.LG005;
    //item.avg = lg0.LB011; //  均價  只有櫃買才有
    item.updown = lg0.LG024; // 漲跌
    item.pricePercent = lg0.LG023; // 漲跌幅
    item.updownRate = lg0.LG022; // (LB006-LB007)/LB035
    item.yield = lg0.LG050; // 殖利率
    item.PEratio = lg0.LG051; // 本益比
    item.ma5 = lg0.LG047;
    item.qtyPercent = jkLib.fixNumber(
      jkLib.fourOutFiveIn(item.qty / item.ma5, 2)
    ); //lb0.LB040盤後才重計得到. ;//成交量增減%
    item.ma10 = lg0.LG048;
    item.sma5 = lg0.LG025;
    item.sma10 = lg0.LG026;
    item.sma20 = lg0.LG027;
    item.sma60 = lg0.LG028;
    //item.sma120 = lg0.LB019;
    //item.sma240 = lg0.LB020;

    item.bias5 = jkLib.fourOutFiveIn(
      (item.close - item.sma5) / item.yClose,
      3
    );
    item.bias10 = jkLib.fourOutFiveIn(
      (item.close - item.sma10) / item.yClose,
      3
    );
    item.bias20 = jkLib.fourOutFiveIn(
      (item.close - item.sma20) / item.yClose,
      3
    );
    item.sma5Dir = this.compareOldNew(lg1.LG025, lg0.LG025, 0);
    item.sma10Dir = this.compareOldNew(lg1.LG026, lg0.LG026, 0);
    item.sma20Dir = this.compareOldNew(lg1.LG027, lg0.LG027, 0);
    item.sma60Dir = this.compareOldNew(lg1.LG028, lg0.LG028, 0);
    item.isSmaUp3 = this.is3Sun(item);
    item.isSmaUp4 = this.is4Dragon(item);
    if (item.isSmaUp3) item.analysis.push("三陽開泰");
    if (item.isSmaUp4) item.analysis.push("四海遊龍");
    this.reCalc(item);
  }

  compareOldNew(old1: number, new1: number, dir: number): number {
    let r = 0;

    if (old1 === new1) {
      r = 0; // SMA5-方向  -1:下 0:平 1:上 前一天LB046
    } else if (old1 < new1) {
      if (dir >= 0) {
        r = dir + 1;
      } else {
        r = 1; // 由跌轉漲
      }
    } else {
      // old1 > new1) 轉跌
      if (dir >= 0) {
        r = -1;
      } else {
        r = dir - 1; // 續跌
      }
    }
    return r;
  }
}
// 單一商品.一段時間N分鐘資料

export class minEntityClass {
  stockno!: string;
  date!: string;
  time!: string;
  high!: number;
  low!: number;
  updownRate!: number; // 分漲跌幅/振幅
  yClose!: number; // 昨收
  yQty!: number; // 昨日成交量
  periorQty!: number; // 上一段時間成交量
  periorPrice!: number; // 上一段時間收盤價
  periorMinute!: number; // 間隔分鐘
  qty!: number; //日成交量 LB003
  open!: number; // 日LB005    開盤價
  close!: number; // LB008    收盤價
  score!: number;
  analysis!: string; // 操盤分析
  isSmaUp3!: boolean; //三陽開泰
  isSmaUp4!: boolean; // 四海遊龍
  state!: string;
  highTime!: Date;
  lowTime!: Date;
  importStktn(periorMinute: number, tn0: Stktn, tn1: Stktn) {
    this.periorMinute = periorMinute;
    if (!tn0) return;
    if (!tn1) return;
    // 先設前一段時間
    this.date = tn0.TN009;
    this.periorMinute = periorMinute;
    this.periorPrice = tn1.TN008;
    this.periorQty = tn1.TN003;

    this.stockno = tn0.TN001;
    this.time = tn0.TN002;
    this.qty = tn0.TN003; //    成交張數
    this.open = tn0.TN005; //    開盤價
    this.high = tn0.TN006; //    最高價
    this.low = tn0.TN007; //    最低價
    this.close = tn0.TN008; //    收盤價
    this.date = tn0.TN009; //    日期
    this.updownRate = jkLib.fourOutFiveIn(
      (this.close - this.open) / this.open,
      4
    );
  }
}

/**
 * 追蹤多個商品,多個時間頻率
 */
export class stockBaseClass extends jkBaseLibClass {
  stkma!: Stkma[];
  stocks!: any[];
  twBeginTime8!: string;
  twEndTime8!: string;
  message!: string;
  Stkml!: Stkml[];
  Stklg: Stklg[];
  Stklg01: Stklg[];
  Stklg05: Stklg[];
  Stklg30: Stklg[];
  Stklg60: Stklg[];
  stklb!: Stklb;
  stklg!: Stklg;
  timePerior!: number[]; //時間間隔
  day1!: string;
  day5!: string;
  day10!: string;
  day20!: string;
  day60!: string;
  day120!: string;
  day240!: string;
  day0!: string;
  time0!: string;
  times!: string[];
  stktnPerior!: any[];
  dayDatas: stockListClass[] = [];
  //minDatas: minEntityClass[] = [];
  data0: any;
  data1: any;
  data5: any;
  data10: any;
  data20: any;
  data60: any;
  data120: any;
  data240: any;

  options: any = {
    host: "", // momoUrl, // "scmapi.momoshop.com.tw",
    path: "", // "/GoodsServlet.do",
    method: "GET",
    //body: '',
    headers: {
      //"Content-Length": JSON.stringify(this.jsonBody).length,
      "Content-Type": "application/json", //  "text/plain"
    },
  };
  constructor() {
    super();
    this.Stklg = [];
    this.Stklg01 = [];
    this.Stklg05 = [];
    this.Stklg30 = [];
    this.Stklg60 = [];
  }
  checkKind(data: string, kind: string): boolean {
    let ret: boolean = false;
    data = "," + data + ",";
    kind = "," + kind + ",";
    if (data.toUpperCase().indexOf("ALL") >= 0) ret = true;
    else {
      if (data.toUpperCase().indexOf(kind) >= 0) {
        ret = true;
      }
    }
    return ret;
  }

  calcKD_jk(
    tableName: string,
    data: any[],
    period: number = 9,
    signalPeriod: number = 3
  ) {
    let high: number[] = [];
    let low: number[] = [];
    let close: number[] = [];
    data.forEach((element, index) => {
      if (tableName === "STKLB") {
        high.push(element.LB006);
        low.push(element.LB007);
        close.push(element.LB008);
      }
      if (tableName === "STKLG") {
        high.push(element.LG008);
        low.push(element.LG009);
        close.push(element.LG010);
      }
    });
    let index = 0;
    let min: number;
    let max: number;
    let RSV: number;
    let k: number;
    let periodK: number = 0.5;
    let periodD: number = 0.5;
    let d: number;
    for (let i = 0; i < close.length - period; i++) {
      // 未成熟隨機值(RSV) RSV = (第n天收盤價-n天內最低價)/(n天內最高價-n天內最低價)*100%
      max = this.arrayMax(high, i, period);
      min = this.arrayMin(low, i, period);
      RSV = (close[i + period - 1] - min) / (max - min);
      // 再用RSV計算當日的K值和D值 K = 1/3(RSV)+2/3(昨日K值) D = 1/3(K值)+2/3(昨日D值)
      k = RSV / 3 + (periodK * 2) / 3;
      d = k / 3 + (periodD * 2) / 3;
      // (如果無前一日的K值或D值，則用50%代入)
      if (tableName === "STKLB") {
        data[i + period - 1].LB025 = k;
        data[i + period - 1].LB026 = d;
      }
      if (tableName === "STKLG") {
        data[i + period - 1].LG029 = k;
        data[i + period - 1].LG030 = d;
      }
      periodK = k;
      periodD = d;
    }
  }
  calcMA(tableName: string, data: any, period: number) {
    //SMA.calculate({period : 5, values : [1,2,3,4,5,6,7,8,9]});
    // Simple Moving Average，簡稱SMA）、加權移動平均線（Weighted Moving Average，簡稱WMA）和指數平滑移動平均線（Exponential Moving Average，簡稱EMA）
    // 10個開盤日內每日的收盤價進行加總然後再除以時間區間內所包含的時間單位10天，最後得到10日的移動平均線
    let values: any[] = [];
    if (data.length === 0) return;
    data.forEach((element: any) => {
      if (tableName === "STKLB") values.push(element.LB003); // 成交張數
      if (tableName === "STKLG") values.push(element.LG005); // 成交張數
    });
    //let input : MAInput = new MAInput(period,values);
    let input = { period: period, values: values };
    let smaData = SMA.calculate(input); // 若 period=5 則前面要跳過4天.輸入60天 得到 56天
    let mFieldName: string = "";
    if (tableName === "STKLB") {
      switch (period) {
        case 5:
          mFieldName = "LB016";
          break;
        case 10:
          mFieldName = "LB017";
          break;
      }
    }
    if (tableName === "STKLG") {
      switch (period) {
        case 5:
          mFieldName = "LG047";
          break;
        case 10:
          mFieldName = "LG048";
          break;
      }
    }
    let mRow: number = period - 1;
    let i: number = 0;
    while (mRow < data.length) {
      data[mRow][mFieldName] = smaData[i];
      i += 1;
      mRow += 1;
    }
  }
  calcSMA(tableName: string, data: any, period: number) {
    //SMA.calculate({period : 5, values : [1,2,3,4,5,6,7,8,9]});
    // Simple Moving Average，簡稱SMA）、加權移動平均線（Weighted Moving Average，簡稱WMA）和指數平滑移動平均線（Exponential Moving Average，簡稱EMA）
    // 10個開盤日內每日的收盤價進行加總然後再除以時間區間內所包含的時間單位10天，最後得到10日的移動平均線
    if (data.length === 0) return;
    let values: any[] = [];

    data.forEach((element: any) => {
      if (tableName === "STKLB") {
        values.push(element.LB008); // 收盤價
      }
      if (tableName === "STKLG") {
        values.push(element.LG010); // 收盤價
      }
    });
    //let input : MAInput = new MAInput(period,values);
    let input = { period: period, values: values };
    let smaData = SMA.calculate(input); // 若 period=5 則前面要跳過4天.輸入60天 得到 56天
    let mFieldName: string = "";
    if (tableName === "STKLB") {
      switch (period) {
        case 5:
          mFieldName = "LB012";
          break;
        case 10:
          mFieldName = "LB013";
          break;
        case 20:
          mFieldName = "LB014";
          break;
        case 60:
          mFieldName = "LB018";
          break;
        case 120:
          mFieldName = "LB019";
          break;
        case 240:
          mFieldName = "LB020";
          break;
        case 1200:
          mFieldName = "LB021";
          break;
        case 2160:
          mFieldName = "LB022";
          break;
      }
    }
    if (tableName === "STKLG") {
      switch (period) {
        case 5:
          mFieldName = "LG025";
          break;
        case 10:
          mFieldName = "LG026";
          break;
        case 20:
          mFieldName = "LG027";
          break;
        case 60:
          mFieldName = "LG028";
          break;
        /*case 120: mFieldName = 'LB019'
                    break;
                case 240: mFieldName = 'LB020'
                    break;
                case 1200: mFieldName = 'LB021'
                    break;
                case 2160: mFieldName = 'LB022'
                    break;*/
      }
    }
    let mRow: number = period - 1;
    let i: number = 0;
    while (mRow < data.length) {
      data[mRow][mFieldName] = smaData[i];
      i += 1;
      mRow += 1;
    }
  }
  STKLBcalcSMAUpDown(data: any) {
    if (data.length === 0) return;
    let ud5: number = 0;
    let ud10: number = 0;
    let ud20: number = 0;
    let ud60: number = 0;
    for (let i = 0; i < data.length; i++) {
      if (i === 0) {
        ud5 = 0;
        ud10 = 0;
        ud20 = 0;
      } else {
        if (data[i - 1].LB012 === data[i].LB012) {
          ud5 = 0;
        }
        if (data[i - 1].LB012 > data[i].LB012) {
          //跌
          if (ud5 < 0) {
            // 原本跌續跌
            ud5 = ud5 - 1;
          } else {
            ud5 = -1; // 原本漲變跌
          }
        }
        if (data[i - 1].LB012 < data[i].LB012) {
          //漲
          if (ud5 > 0) {
            ud5 = ud5 + 1; // 原本漲續漲
          } else {
            ud5 = 1; // 原本跌變漲
          }
        }
        //------------------------------
        if (data[i - 1].LB013 === data[i].LB013) {
          ud10 = 0;
        }
        if (data[i - 1].LB013 > data[i].LB013) {
          //跌
          if (ud10 < 0) {
            // 原本跌續跌
            ud10 = ud10 - 1;
          } else {
            ud10 = -1; // 原本漲變跌
          }
        }
        if (data[i - 1].LB013 < data[i].LB013) {
          //漲
          if (ud10 > 0) {
            ud10 = ud10 + 1; // 原本漲續漲
          } else {
            ud10 = 1; // 原本跌變漲
          }
        }
        //------------------------------
        if (data[i - 1].LB014 === data[i].LB014) {
          ud20 = 0;
        }
        if (data[i - 1].LB014 > data[i].LB014) {
          //跌
          if (ud20 < 0) {
            // 原本跌續跌
            ud20 = ud20 - 1;
          } else {
            ud20 = -1; // 原本漲變跌
          }
        }
        if (data[i - 1].LB014 < data[i].LB014) {
          //漲
          if (ud20 > 0) {
            ud20 = ud20 + 1; // 原本漲續漲
          } else {
            ud20 = 1; // 原本跌變漲
          }
        }
        //------------------------------
        if (data[i - 1].LB018 === data[i].LB018) {
          ud60 = 0;
        }
        if (data[i - 1].LB018 > data[i].LB018) {
          //跌
          if (ud60 < 0) {
            // 原本跌續跌
            ud60 = ud60 - 1;
          } else {
            ud60 = -1; // 原本漲變跌
          }
        }
        if (data[i - 1].LB018 < data[i].LB018) {
          //漲
          if (ud60 > 0) {
            ud60 = ud60 + 1; // 原本漲續漲
          } else {
            ud60 = 1; // 原本跌變漲
          }
        }
        data[i].LB028 = ud5;
        data[i].LB029 = ud10;
        data[i].LB030 = ud20;
        data[i].LB045 = ud60;
      }
    }
  }
  // 指數移動平均（英語：exponential moving average，EMA或EXMA）是以指數式遞減加權的移動平均。 各數值的加權影響力隨時間而指數式遞減，越近期的數據加權影響力越重，但較舊的數據也給予一定的加權值。 右圖是一例子。 ，所以，N=19天，代表α=0.1。
  calcEMA(values: any[], period: number = 8): number[] {
    let ret: number[];
    //const EMA = require('technicalindicators').EMA
    //let period = 8;
    //let values = [1,3,4,5,6,7,8,9,10,11,12,13,14,15];
    ret = EMA.calculate({ period: period, values: values });
    return ret;
  }
  calcMacd(
    table: string,
    data: any[],
    fastPeriod: number = 12,
    slowPeriod: number = 26,
    signalPeriod: number = 9
  ) {
    //{MACD: 1.82, histogram: 0.41, signal: 1.41}
    // DIF-OSC=MACD
    // values: 收盤價的指數移動平均值EMA（12日／26日） exponential moving average，EMA或EXMA

    //快速 n=12 EMA(n)=(前一日EMA(n) × (n-1)+今日收盤價 × 2) ÷ (n+1)
    //慢速 m=26 EMA(m)=(前一日EMA(m) × (m-1)+今日收盤價 × 2) ÷ (m+1)
    //  DIF=EMA(n)－EMA(m)
    // 將得出來的兩個數值相減，計算出兩者間的差離值(DIF)後，再計算n日DIF的EMA
    // x=9 MACD(x)=(前一日xMACD × (x-1)+DIF × 2) ÷ (x+1)
    // {MACD: 1.82, histogram 柱形圖 直方圖 : 0.41, signal: 1.41 訊號線（DEM值，又稱MACD值）} MACD = histogram + signal
    // histogram柱形圖 直方圖 OSC = MACD(value)-signal(DIF)
    /*
            國內MACD名詞定義：(國內看盤軟體用法)

            快線 DIF(差離值)，將兩條EMA線相減，得出的差額就是差離值(DIF)，代表短線EMA偏離長線EMA的情形。
            慢線 MACD (也稱DEM)，計算出DIF後，再取DIF的N日指數移動平均線EMA(一般使用9日天數)即得，就是把DIF再取一次平均，稱為MACD線或DEM，意思是短期與長期乖離程度的平均值。
            柱狀圖 DIF-MACD：一般會將DIF-MACD兩者相減，繪成柱狀圖(直方圖、棒狀圖)
            快線 MACD       -> DIF
            慢線 signal     -> DEA
            柱狀圖 histogram  -> MACD
            國外MACD名詞定義：(國外看盤軟體用法)

            快線 MACD，將兩條EMA線相減 12EMA-26EMA，就是MACD線，等同於國內的DIF線
            慢線 信號線 Signal line 或 Trigger line：將MACD線取9日指數移動平均EMA，等同於國內的MACD線
            柱狀圖 MACD histogram：將快線MACD減掉慢線，得到柱狀圖(直方圖、棒狀圖)
        */
    let values: number[] = [];
    if (table === "STKLB") {
      data.forEach((element, index) => {
        values.push(element.LB008);
      });
      let input: MACDInput = new MACDInput(values);
      input.SimpleMAOscillator = true;
      input.SimpleMASignal = true;
      input.fastPeriod = fastPeriod;
      input.signalPeriod = signalPeriod;
      input.slowPeriod = slowPeriod;
      let res: MACDOutput[] = macd(input);//macd(values, slowPeriod, fastPeriod, signalPeriod);
      for (let i = 0; i < data.length; i++) {
        data[i].LB023 /*快線 DIF */ = res[i].MACD;//  res.MACD[i];
        data[i].LB024 /*慢線 MACD9*/ =
          res[i].signal; //res.signal[i]; /*慢線 信號線 Signal line */
        data[i].LB027 /*OSC histogram*/ = res[i].histogram; //res.histogram[i];
      }
    } else if (table === "STKLG") {
      data.forEach((element, index) => {
        values.push(element.LG010);
      });
      let input: MACDInput = new MACDInput(values);
      input.SimpleMAOscillator = true;
      input.SimpleMASignal = true;
      input.fastPeriod = fastPeriod;
      input.signalPeriod = signalPeriod;
      input.slowPeriod = slowPeriod;

      let res: MACDOutput[] = macd(input);//macd(values, slowPeriod, fastPeriod, signalPeriod);
      for (let i = 0; i < data.length - signalPeriod; i++) {
        data[i + signalPeriod - 1].LG020 /*快線 DIF */ = res[i].MACD;
        data[i + signalPeriod - 1].LG019 /*慢線 MACD9*/ =
          res[i].signal; /*慢線 信號線 Signal line */
        data[i + signalPeriod - 1].LG021 /*OSC histogram*/ = res[i].histogram;
      }
    }
  }
  /*
    calcMACD(
      data: any[],
      fastPeriod: number = 12,
      slowPeriod: number = 26,
      signalPeriod: number = 9
    ) {
      / *
              普遍使用MACD(12,26,9)，就是12日與26日的EMA(指數平滑平均值)，與9日MACD值，目前也還沒看到有人用其它的參數，其計算步驟如下：
              每日需求指數(Demand Index，DI)，DI = (最高價 + 最低價 + 2 × 收盤價) ÷ 4。 (註1)
              首日EMA12 = 12天內DI 總和 ÷ 12
              首日EMA26 = 26天內DI 總和 ÷ 26
              當日平滑修正值 EMA12 = [前一日EMA12 × (12 - 1) + 今日DI × 2] ÷ (12+1)
              簡化後 EMA12 = 前一日EMA12 × (11/13) + 今日DI × 2/13
              當日平滑修正值 EMA26 = [前一日EMA26 × (26 - 1) + 今日DI × 2] ÷ (26+1)
              簡化後 EMA26 = 前一日EMA26 × (25/27) + 今日DI × 2/27
              差離值DIF = 12日EMA - 26日EMA
              首日MACD = 9天內DIF總和 ÷ 9
              MACD = (前一日MACD × (9 - 1) + 今日DIF × 2) ÷ (9 + 1)
              簡化後 MACD = (前一日MACD × 8/10 + 今日DIF × 2/10
              OSC = DIF - MACD
           * /
      // DIF-OSC=MACD
      // values: 收盤價的指數移動平均值EMA（12日／26日） exponential moving average，EMA或EXMA
      let DI:number[] = [];
      let emaFast = [];
      let emaSlow = [];
      let n: number;
      data.forEach((element, index) => {
        n = (element.LB006 + element.LB007 + 2 * element.LB008) / 4;
        DI.push(n);
        if (index < fastPeriod) {
          emaFast.push(0);
        } else {
          let fastN = this.arrayAvg(DI, index - fastPeriod, fastPeriod);
          emaFast.push(fastN);
        }
        //首日EMA26 = 26天內DI 總和 ÷ 26
        if (index < slowPeriod) {
          emaSlow.push(0);
        } else {
          let slowN = this.arrayAvg(DI, index - slowPeriod, slowPeriod);
          emaSlow.push(slowN);
        }
        //當日平滑修正值 EMA12 = [前一日EMA12 × (12 - 1) + 今日DI × 2] ÷ (12+1)
        //簡化後 EMA12 = 前一日EMA12 × (11/13) + 今日DI × 2/13
  
        //當日平滑修正值 EMA26 = [前一日EMA26 × (26 - 1) + 今日DI × 2] ÷ (26+1)
        //簡化後 EMA26 = 前一日EMA26 × (25/27) + 今日DI × 2/27
  
        //差離值DIF = 12日EMA - 26日EMA
        //首日MACD = 9天內DIF總和 ÷ 9
  
        //MACD = (前一日MACD × (9 - 1) + 今日DIF × 2) ÷ (9 + 1)
        //簡化後 MACD = (前一日MACD × 8/10 + 今日DIF × 2/10
  
        //OSC = DIF - MACD
      });
      let di = [];
      let high = [];
      let low = [];
      let close = [];
      data.forEach((element, index) => {
        high.push(element.LB006);
        low.push(element.LB007);
        close.push(element.LB008);
      });
      let index = 0;
      let min: number;
      let max: number;
    }
    */
  /*
   calcMACD_old(
     data: any[],
     fastPeriod: number = 12,
     slowPeriod: number = 26,
     signalPeriod: number = 9,
     SimpleMAOscillator: boolean = false,
     SimpleMASignal: boolean = false
   ) {
     return;
     //{MACD: 1.82, histogram: 0.41, signal: 1.41}
     // DIF-OSC=MACD
     // values: 收盤價的指數移動平均值EMA（12日／26日） exponential moving average，EMA或EXMA
     let values = [];
     data.forEach((element, index) => {
       values.push(element.LB008);
     });
     var macdInput = {
       values: values, // [127.75, 129.02, 132.75, 145.40, 148.98, 137.52, 147.38, 139.05, 137.23, 149.30, 162.45, 178.95, 200.35, 221.90, 243.23, 243.52, 286.42, 280.27],
       fastPeriod: fastPeriod, // def:5
       slowPeriod: slowPeriod, // def:8
       signalPeriod: signalPeriod, //
       SimpleMAOscillator: SimpleMAOscillator, // false
       SimpleMASignal: SimpleMASignal, // false
     };
     let res;
     // res = MACD.calculate(macdInput);  FIXME:有問題
     //快速 n=12 EMA(n)=(前一日EMA(n) × (n-1)+今日收盤價 × 2) ÷ (n+1)
     //慢速 m=26 EMA(m)=(前一日EMA(m) × (m-1)+今日收盤價 × 2) ÷ (m+1)
     //  DIF=EMA(n)－EMA(m)
     // 將得出來的兩個數值相減，計算出兩者間的差離值(DIF)後，再計算n日DIF的EMA
     // x=9 MACD(x)=(前一日xMACD × (x-1)+DIF × 2) ÷ (x+1)
     // {MACD: 1.82, histogram 柱形圖 直方圖 : 0.41, signal: 1.41 訊號線（DEM值，又稱MACD值）} MACD = histogram + signal
     // DIF-OSC=MACD  ???
     // histogram柱形圖 直方圖 OSC = MACD(value)-signal(DIF)
     / *
             國內MACD名詞定義：(國內看盤軟體用法)
 
             快線 DIF(差離值)，將兩條EMA線相減，得出的差額就是差離值(DIF)，代表短線EMA偏離長線EMA的情形。
             慢線 MACD (也稱DEM)，計算出DIF後，再取DIF的N日指數移動平均線EMA(一般使用9日天數)即得，就是把DIF再取一次平均，稱為MACD線或DEM，意思是短期與長期乖離程度的平均值。
             柱狀圖 DIF-MACD：一般會將DIF-MACD兩者相減，繪成柱狀圖(直方圖、棒狀圖)
             快線 MACD       -> DIF
             慢線 signal     -> DEA
             柱狀圖 histogram  -> MACD
             國外MACD名詞定義：(國外看盤軟體用法)
 
             快線 MACD，將兩條EMA線相減 12EMA-26EMA，就是MACD線，等同於國內的DIF線
             慢線 信號線 Signal line 或 Trigger line：將MACD線取9日指數移動平均EMA，等同於國內的MACD線
             柱狀圖 MACD histogram：將快線MACD減掉慢線，得到柱狀圖(直方圖、棒狀圖)
         * /
     res.forEach((element, index) => {
       data[index].LB023 / *快線 DIF * / = this.iif(
         element.MACD === undefined,
         0,
         element.MACD
       );
       data[index].LB024 / *慢線 MACD9* / = this.iif(
         element.signal / *慢線 信號線 Signal line * / === undefined,
         0,
         element.signal
       ); //
       data[index].LB027 / *OSC histogram* / = this.iif(
         element.histogram === undefined,
         0,
         element.histogram
       );
     });
 
     let ema12 = this.calcEMA(values, 12);
     let ema26 = this.calcEMA(values, 26);
     let ema = [];
     for (let i = 0; i < ema12.length; i++) {
       // ema12.forEach((element,index)=>{
       if (ema[26] !== 0) {
         ema.push(ema12[i] - ema26[i]); // DIF 差離值
       } else ema.push(0);
     }
     return;
   }
 */
  // CCI
  async updateCCI(
    stockNo1: string,
    stockNo2: string,
    period: number,
    date1: string,
    date2: string,
    ret: jkRestReturn
  ) {
    //有點類似乖離率，要求其極端極，如附圖２所示，當CCI的兩條線（附表１中最後兩欄的數字）形成死亡Ｓ點交叉時賣出，形成黃金Ｂ點交叉時買進。不過，還是要注意Ｂ或Ｓ點出現時，典型價格的平均線走勢是向上或向下，圖中我們可以發現當CCI值在零附近時，因為平均線還在向上，所以形成的買進點的可靠性極高，隨後股價都會上漲；但當CCI在較大的負值時，所形成的買進點，會有較高的失敗率。
    let inputCCI = {
      open: [
        23.94, 23.85, 23.94, 23.73, 23.6, 23.46, 23.53, 23.73, 24.09, 23.95,
        23.92, 24.04, 23.83, 24.05, 24.89, 24.95, 24.91, 25.24, 25.13, 25.26,
        24.74, 24.36, 24.49, 24.7, 24.65, 24.48, 24.46, 24.62, 23.81, 23.91,
      ],
      high: [
        24.2, 24.07, 24.04, 23.87, 23.67, 23.59, 23.8, 23.8, 24.3, 24.15, 24.05,
        24.06, 23.88, 25.14, 25.2, 25.07, 25.22, 25.37, 25.36, 25.26, 24.82,
        24.44, 24.65, 24.84, 24.75, 24.51, 24.68, 24.67, 23.84, 24.3,
      ],
      low: [
        23.85, 23.72, 23.64, 23.37, 23.46, 23.18, 23.4, 23.57, 24.05, 23.77,
        23.6, 23.84, 23.64, 23.94, 24.74, 24.77, 24.9, 24.93, 24.96, 24.93,
        24.21, 24.21, 24.43, 24.44, 24.2, 24.25, 24.21, 24.15, 23.63, 23.76,
      ],
      close: [
        23.89, 23.95, 23.67, 23.78, 23.5, 23.32, 23.75, 23.79, 24.14, 23.81,
        23.78, 23.86, 23.7, 24.96, 24.88, 24.96, 25.18, 25.07, 25.27, 25.0,
        24.46, 24.28, 24.62, 24.58, 24.53, 24.35, 24.34, 24.23, 23.76, 24.2,
      ],
      period: 20,
    };
    var cci = new CCI(inputCCI);
    console.debug("cci:", cci.result);

    let input1 = {
      open: [],
      high: [],
      low: [],
      close: [],
      period: 20,
    };
    var cci = new CCI(input1);

    var results: number[] = [];

    inputCCI.close.forEach((price, index) => {
      var result = cci.nextValue({
        open: inputCCI.open[index],
        high: inputCCI.high[index],
        low: inputCCI.low[index],
        close: inputCCI.close[index],
      });
      if (result != undefined) {
        results.push(result);
      }
    });

    console.debug("nextValue:", results);
    console.debug("updateCCI " + stockNo1 + " " + date1 + "~" + date2);
  }

  calcBB(
    tableName: string,
    data: any,
    period: number = 20,
    stdDev: number = 2
  ) {
    let values: number[] = [];
    if (data.length === 0) return;
    data.forEach((element: any) => {
      if (tableName === "STKLB") values.push(element.LB008);
      if (tableName === "STKLG") values.push(element.LG010); // LG010    收盤價
    });
    //let input : MAInput = new MAInput(period,values);
    let smaData = this.calcBollingerBands(values, period, stdDev);
    let mRow: number = period - 1;
    let i: number = 0;
    while (mRow < data.length) {
      //data[mRow][mFieldName] = smaData[i]
      if (!smaData[i]) {
        console.error(
          "calcBB error",
          tableName,
          "period:",
          period,
          stdDev,
          data.length,
          mRow,
          i
        );
      } else {
        if (tableName === "STKLB") {
          data[mRow].LB032 = smaData[i].upper; // BBand上軌
          data[mRow].LB034 = smaData[i].lower; // BBand下軌
          data[mRow].LB033 = smaData[i].middle; //中軌_B指標
        }
        if (tableName === "STKLG") {
          data[mRow].LG014 = jkLib.fourOutFiveIn(smaData[i].upper, 3); // BBand上軌
          data[mRow].LG015 = jkLib.fourOutFiveIn(smaData[i].lower, 3); // BBand下軌
          data[mRow].LG017 = jkLib.fourOutFiveIn(smaData[i].middle, 3); //中軌_B指標
          let lg016 = jkLib.fixNumber(smaData[i].pb);
          data[mRow].LG016 = this.fourOutFiveIn(lg016, 4); // BBAND帶寬
        }
      }

      i += 1;
      mRow += 1;
    }
  }
  // Bollinger Bands (BB) 布林通道 period=20 stdDev=2
  //BollingerBandsOutput { middle: number; upper: number; lower: number;    pb: number;}
  calcBollingerBands(
    close: number[],
    period: number = 20,
    stdDev: number = 2
  ): BollingerBandsOutput[] {
    //var BB = require('technicalindicators').BollingerBands
    let input = {
      period: period,
      values: close, // [48.16, 48.61, 48.75, 48.63, 48.74, 49.03, 49.07, 49.32, 49.91, 50.13, 49.53, 49.50, 49.75, 50.03, 50.31, 50.52, 50.41, 49.34, 49.37, 50.23, 49.24, 49.93, 48.43, 48.18, 46.57, 45.41, 47.77, 47.72, 48.62, 47.85],
      stdDev: stdDev,
    };
    //input.values = close;
    return BB.calculate(input);
  }
  // 由1分K產生 N分K
  calcStklg(minute: number, lg1: Stklg[]): Stklg[] {
    let lg2: Stklg[] = [];
    let mod = 0;
    let lg: Stklg;
    let oldLG011 = 0;
    let total = 0;
    let min = 0;
    let max = 0;
    let close = 0;
    for (let i = 0; i < lg1.length; i++) {
      lg = new Stklg();
      mod = i % minute;
      if (mod === 0) {
        total = 0;
        lg.LG005 = 0;
        lg.LG006 = 0;
        this.defaultManagerField(lg, true);
        lg.LG001 = lg1[i].LG001;
        lg.LG004 = lg1[i].LG004; // 商品代號                    V   10
        lg.LG002 = this.zeroAtFirst(minute, 4); //    周期(分)                    V    4   0001 0005 0030 0060  日線 月線 周線
        lg.LG003 = lg1[i].LG003; // LG003    時間                        V    8   hhmm
        lg.LG007 = lg1[i].LG007; //   開盤價                      N   11.3
        min = lg1[i].LG009;
        max = lg1[i].LG008;
      }
      close = lg1[i].LG010;
      if (min === 0) {
        min = close;
      }
      if (min > lg1[i].LG009) {
        min = lg1[i].LG009;
      }
      if (max < lg1[i].LG008) {
        max = lg1[i].LG008;
      }
      lg.LG010 = close; //    收盤價
      lg.LG008 = max; //    最高價                      N   11.3
      lg.LG009 = min; //    最低價                      N   11.3

      lg.LG005 = lg.LG005 + lg1[i].LG005; //    成交張數                    N   11   unit
      lg.LG006 = lg.LG006 + lg.LG010 * lg.LG005; //   成交量                      N   11   TN003*TN008
      lg.LG011 = oldLG011; //    昨收價                      N   11.3
      oldLG011 = lg.LG010;
      if (mod === minute - 1) {
        lg2.push(lg);
      }
    }
    return lg2;
  }
  number2Direct(n: number): number {
    if (n === 0) {
      return 0;
    }
    if (n > 0) {
      return 1;
    }
    if (n < 0) {
      return -1;
    }
    return 0;
  }
  //stockno 逗號分開.'' 表示全部
  compareOldNew(old1: number, new1: number, dir: number): number {
    let r = 0;
    if (old1 === new1) {
      r = 0; // SMA5-方向  -1:下 0:平 1:上 前一天LB046
    } else if (old1 < new1) {
      if (dir >= 0) {
        r = dir + 1;
      } else {
        r = 1; // 由跌轉漲
      }
    } else {
      // old1 > new1) 轉跌
      if (dir >= 0) {
        r = -1;
      } else {
        r = dir - 1; // 續跌
      }
    }
    return r;
  }
  defaultManagerField(table: any, isInsert: boolean) {
    try {
      if (isInsert) {
        table.COMPANY = login.dbname; // FIXME: 這裡要改成系統參數
        table.CREATE_DATE = jkLib.nowDate();
        table.FLAG = 1;
        table.CREATOR = login.userid;
      } else {
        table.MODI_DATE = jkLib.nowDate();
        table.FLAG = (table.FLAG + 1) % 999;
        table.MODIFIER = login.userid;
      }
    } catch (error: any) { }
  }
}

